import { PRE_AUTH_LOCAL_STORAGE_KEYS } from "../const/preAuthConsts";
import { PreAuthReduxStateType } from "./ReduxStateType";

export const PRE_AUTH_INITIAL_STATE: PreAuthReduxStateType["preAuth"] = {
    // pre auth state
    isAuthenticated: undefined, // Root will fetch isAuthenticated as soon as page is loaded
    username: "",
    loading: false,

    // other states cloned here for use pre auth
    isDarkMode: localStorage.getItem(PRE_AUTH_LOCAL_STORAGE_KEYS.isDarkMode) === "true",

    routes: {
        pageRoutes: [], // Added in reducer so that they ar enot part of the initial state for tests and storybook
        redirectRoutes: [], // No redirect routes in PreAuth yet
        enforcePermissions: false,
    },
};
